<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 面包屑导航 -->
      <div class="breadcrumb-wrapper" v-if="breadcrumbList.length > 0">
        <span
          v-for="(item, index) in breadcrumbList"
          :key="item.id"
          class="breadcrumb-item">
          <span
            :class="['breadcrumb-name', { 'breadcrumb-name-current': index === breadcrumbList.length - 1 && breadcrumbList.length > 1 }]"
            @click="handleBreadcrumbClick(item, index)">
            {{ item.name }}
          </span>
          <span v-if="index < breadcrumbList.length - 1" class="breadcrumb-separator">/</span>
        </span>
        <a-tooltip title="复制路径">
          <a-icon type="copy" class="breadcrumb-copy-icon" @click="handleCopyPath" />
        </a-tooltip>
      </div>
      <div class="table-page-search-wrapper">
        <a-form layout="inline" labelAlign="right">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="文件夹名称">
                <a-input v-model="queryParam.name" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <!-- v-if="advanced" -->
            <a-col :md="8" :sm="24" >
              <a-form-item label="创建时间">
                <a-range-picker
                  v-model="value"
                  format="YYYY-MM-DD"
                  :placeholder="['开始时间', '结束时间']"
                  @change="onChangeTime" />
              </a-form-item>
            </a-col>
            <a-col :md="(!advanced && 6) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>

              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <CreateForm ref="createForm" @ok="getList"></CreateForm>
      <div class="table-operations">
        <a-button
          type="primary"
          @click="handleAdd"
          v-hasPermi="['87aaa547b70e66f84176d5cc3528701bc:0:c']">
          新增
        </a-button>
        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false">
        <span slot="name" slot-scope="text, record">
          <!-- 文件夹类型 -->
          <span
            v-if="record.type !== 1"
            class="folder-name"
            @click="handleFolderClick(record)">
            <a-icon type="folder-open" class="folder-icon" />
            {{ text }}
          </span>
          <!-- 作品类型 -->
          <span v-else class="work-name">
            {{ text }}
            <a
              class="preview-link"
              @click="handlePreviewWork(record)"
              title="预览详情">
              <a-icon type="eye" />
              预览
            </a>
          </span>
        </span>
        <span slot="description" slot-scope="text, record">
          <a-tooltip v-if="text">
            <template #title>
              <div v-html="record.description"></div>
              <!-- 富文本支持 -->
            </template>
            <a> 查看 </a>
          </a-tooltip>
          <span v-else class="description-empty">-</span>
        </span>
        <span slot="action" slot-scope="text, record">
          <!-- 文件夹操作 -->
          <template v-if="record.type !== 1">
            <a @click="$refs.createForm.handleUpdate(record)" v-hasPermi="['87aaa547b70e66f84176d5cc3528701bd:0:d']">
              修改
            </a>
            <a-divider type="vertical" v-hasPermi="['87aaa547b70e66f84176d5cc3528701bq:0:q']" />
            <a-dropdown v-hasPermi="['87aaa547b70e66f84176d5cc3528701bq:0:q', '87aaa547b70e66f84176d5cc3528701br:0:r']">
              <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
                <a-icon type="double-right" />
                更多
              </a>
              <a-menu slot="overlay">
                <a-menu-item v-hasPermi="['87aaa547b70e66f84176d5cc3528701br:0:r']">
                  <a @click="handleDelete(record)" v-hasPermi="['87aaa547b70e66f84176d5cc3528701br:0:r']"> 删除 </a>
                </a-menu-item>
                <a-menu-item v-hasPermi="['87aaa547b70e66f84176d5cc3528701bd:0:d']">
                  <a
                    @click="$refs.CreateFen.handleUpdate(record, undefined, true)"
                    v-hasPermi="['87aaa547b70e66f84176d5cc3528701bc:1:c']">
                    分配
                  </a>
                </a-menu-item>
                <a-menu-item v-hasPermi="['87aaa547b70e66f84176d5cc3528701bq:0:q']">
                  <a
                    @click="$refs.vrDetail.handleUpdate(record)"
                    v-hasPermi="['87aaa547b70e66f84176d5cc3528701bq:0:q']">
                    详情
                  </a>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </template>
          <!-- 作品操作：只显示删除 -->
          <template v-else>
            <a @click="handleDelete(record)" v-hasPermi="['87aaa547b70e66f84176d5cc3528701br:0:r']">
              删除
            </a>
          </template>
        </span>
      </a-table>
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize" />
    </a-card>
    <detail ref="vrDetail"></detail>
    <CreateFen ref="CreateFen"></CreateFen>
  </page-header-wrapper>
</template>
<script>
import { fetchList, delObj } from '@/api/VR/folder'
import CreateForm from './model/CreateForm.vue'
import detail from './model/details.vue'
import CreateFen from './model/CreateFen.vue'
import { listTenant } from '@/api/system/tenant'
import moment from 'moment'
import { mapGetters } from 'vuex'
export default {
  name: 'Work',
  components: {
    detail,
    CreateForm,
    CreateFen,
  },
  computed: {
    userType() {
      return this.$store.state.user.userTentant.type
    },
    ...mapGetters(['userTentant', 'infoUser']),
  },
  props: {
    vrWorkId: {
      type: [String, Number],
    },
  },
  data() {
    return {
      list: [],
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        parentId: 0,
      },
      total: 0,
      value: [],
      // 高级搜索 展开/关闭
      advanced: false,
      loading: false,
      tableSize: 'default',
      tableBordered: true,
      selectedRowKeys: [],
      // 面包屑导航路径
      breadcrumbList: [],
      columns: [
        {
          title: '名称',
          dataIndex: 'name',
          align: 'left',
          scopedSlots: { customRender: 'name' },
        },
        // {
        //   title: '操作人',
        //   dataIndex: 'workName',
        //   key: 'workName',
        // },
        // {
        //   title: '操作时间',
        //   dataIndex: 'workName',
        //   key: 'workName',
        // },
        // {
        //   title: '备注',
        //   dataIndex: 'remark',
        //   key: 'remark',
        // },

        // {
        //   title: '排序',
        //   dataIndex: 'sort',
        //   align: 'center'

        // },
        {
          title: '修改时间',
          dataIndex: 'updateTime',
          align: 'center',
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          align: 'center',
        },
        {
          title: '备注',
          dataIndex: 'description',
          align: 'center',
          scopedSlots: { customRender: 'description' },
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          align: 'center',
        },
      ],
    }
  },
  methods: {
    getList() {
      // 确保 parentId 始终有值，默认为 0
      if (this.queryParam.parentId === undefined || this.queryParam.parentId === null) {
        this.queryParam.parentId = 0
      }
      this.loading = true
      fetchList(this.queryParam).then((res) => {
        this.list = res.data.records
        this.total = res.data.total
        this.loading = false
      })
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        postCode: undefined,
        postName: undefined,
        status: undefined,
        parentId: 0,
      }
      this.value = []
      this.breadcrumbList = []
      this.handleQuery()
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      let ids = []
      if (row.id) {
        ids = [row.id]
      } else {
        ids = this.ids
      }
      this.$confirm({
        title: '是否确认删除此数据?',
        onOk() {
          return delObj(ids).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() { },
      })
    },
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download(
            'vr/works/export',
            {
              ...that.queryParam,
            },
            `post_${new Date().getTime()}.xlsx`
          )
        },
        onCancel() { },
      })
    },
    onChangeTime(e) {
      this.queryParam.createBeginTime = moment(e[0]).startOf('day').format('YYYY-MM-DD') + ' 00:00:00'
      this.queryParam.createEndTime = moment(e[1]).endOf('day').format('YYYY-MM-DD') + ' 23:59:59'
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    // handleSearch(value) {
    //   console.log(value, 'valuevalue')
    //   this.getAgent(value)
    // },
    // 查代理商和企业
    // getAgent(name, e) {
    //   listTenant({ pageNum: 1, pageSize: 100, type: e, name: name }).then((res) => {
    //     if (e == 1) {
    //       this.agentList = res.data.records
    //     }else{
    //       this.agentList = res.data.records
    //     }
    //     // console.log(this.agentList, '的点点滴滴this.agentListthis.agentList')
    //   })
    // },
    handleRetry(row) {
      const that = this
      this.$confirm({
        title: '是否确认重试切图?',
        onOk() {
          return retryObj({ workId: row.workId }).then(() => {
            that.getList()
            that.$message.success('操作成功', 3)
          })
        },
        onCancel() { },
      })
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    /** 文件夹名称点击事件 */
    handleFolderClick(record) {
      // 将当前文件夹添加到面包屑路径中
      this.breadcrumbList.push({
        id: record.id,
        name: record.name,
      })
      // 设置 parentId 为当前点击的文件夹 ID
      this.queryParam.parentId = record.id
      // 重置页码到第一页
      this.queryParam.pageNum = 1
      // 调用查询接口
      this.getList()
    },
    /** 面包屑点击事件 */
    handleBreadcrumbClick(item, index) {
      // 如果点击的是最后一个（当前目录）
      if (index === this.breadcrumbList.length - 1) {
        // 如果只有一项，说明在第一级文件夹，点击返回到根目录
        if (this.breadcrumbList.length === 1) {
          this.breadcrumbList = []
          this.queryParam.parentId = 0
          this.queryParam.pageNum = 1
          this.getList()
        }
        // 如果有多项，不做任何操作（保持原逻辑）
        return
      }
      // 点击非最后一个项，导航到对应层级
      this.breadcrumbList = this.breadcrumbList.slice(0, index + 1)
      this.queryParam.parentId = item.id
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 新增按钮操作 */
    handleAdd() {
      // 获取当前的parentId，如果当前在某个文件夹下，就传递该文件夹的ID
      const currentParentId = this.queryParam.parentId || 0
      this.$refs.createForm.handleAdd(currentParentId)
    },
    /** 复制路径 */
    handleCopyPath() {
      // 将路径格式化为字符串，用 / 分隔
      const pathText = this.breadcrumbList.map(item => item.name).join(' / ')
      // 使用 Clipboard API 复制到剪贴板
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(pathText).then(() => {
          this.$message.success('路径已复制到剪贴板')
        }).catch(() => {
          // 如果 Clipboard API 失败，使用传统方法
          this.fallbackCopyText(pathText)
        })
      } else {
        // 降级方案：使用传统方法
        this.fallbackCopyText(pathText)
      }
    },

    /** 预览作品详情 */
    handlePreviewWork(record) {
      // 跳转到VR预览页面
      const previewUrl = `https://vrce.guandaojia.cn/?id=${record.objId}`
      window.open(previewUrl, '_blank')
    },
    /** 降级复制方法 */
    fallbackCopyText(text) {
      const textArea = document.createElement('textarea')
      textArea.value = text
      textArea.style.position = 'fixed'
      textArea.style.left = '-999999px'
      textArea.style.top = '-999999px'
      document.body.appendChild(textArea)
      textArea.focus()
      textArea.select()
      try {
        document.execCommand('copy')
        this.$message.success('路径已复制到剪贴板')
      } catch (err) {
        this.$message.error('复制失败，请手动复制')
      }
      document.body.removeChild(textArea)
    },
  },
  created() {
    console.log(this.userType, 'userTypeuserType')
    // if(this.userType==0){

    // }
    this.getList()
  },
  mounted() { },
}
</script>
<style scoped>
.folder-name {
  color: #0052D9;
  cursor: pointer;
  transition: all 0.3s;
  display: flex;
  align-items: center;
}

.folder-icon {
  margin-right: 6px;
  color: #0052D9;
}

.folder-name:hover {
  text-decoration: underline;
}

.breadcrumb-wrapper {
  margin-bottom: 16px;
  padding: 12px 16px;
  background: #fafafa;
  border-radius: 4px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.breadcrumb-item {
  display: flex;
  align-items: center;
}

.breadcrumb-name {
  color: #0052D9;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 14px;
}

.breadcrumb-name:hover {
  text-decoration: underline;
}

.breadcrumb-name-current {
  color: #000;
  font-weight: 700;
  cursor: default;
}

.breadcrumb-name-current:hover {
  text-decoration: none;
}

.breadcrumb-separator {
  margin: 0 8px;
  color: #8c8c8c;
  font-size: 14px;
}

.breadcrumb-copy-icon {
  margin-left: 12px;
  color: #0052D9;
  cursor: pointer;
  font-size: 16px;
  transition: all 0.3s;
}

.breadcrumb-copy-icon:hover {
  color: #1890ff;
}

.description-empty {
  color: #bfbfbf;
}

.work-name {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #000;
  font-weight: normal;
}

.preview-link {
  margin-left: 8px;
  color: #1890ff;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 14px;
}

.preview-link:hover {
  color: #40a9ff;
}
</style>
